import { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { Lang, langConfig, translations } from "@/i18n/translations";

type I18nContextType = {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: typeof translations["fr"];
  dir: "ltr" | "rtl";
  isRtl: boolean;
};

const I18nContext = createContext<I18nContextType | null>(null);

export const I18nProvider = ({ children }: { children: ReactNode }) => {
  const [lang, setLangState] = useState<Lang>(() => {
    const saved = localStorage.getItem("mocharaka-lang");
    return (saved as Lang) || "fr";
  });

  const setLang = (newLang: Lang) => {
    setLangState(newLang);
    localStorage.setItem("mocharaka-lang", newLang);
  };

  useEffect(() => {
    const config = langConfig[lang];
    document.documentElement.dir = config.dir;
    document.documentElement.lang = lang === "zgh" ? "ber" : lang;
  }, [lang]);

  const value: I18nContextType = {
    lang,
    setLang,
    t: translations[lang],
    dir: langConfig[lang].dir,
    isRtl: langConfig[lang].dir === "rtl",
  };

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
